export const GET_AGREEMENTS = 'GET_AGREEMENTS';
export const SET_AGREEMENTS = 'SET_AGREEMENTS';
export const SET_AGREEMENTSLOADING_FALSE = 'SET_AGREEMENTSLOADING_FALSE';
